import FetchClient from 'ha/helpers/FetchClient';
import createMakeCall from 'ha/services/apiV2/createMakeCall';

import {
  createPaymentRequest,
  createPaymentPlan,
  getPaymentRequests,
  getPaymentRequestByHandle,
  payPaymentRequestV2,
  payPaymentRequestV2Confirm,
  cancelPaymentRequest,
  submitIdealSource,
  checkIdealStatus,
} from './paymentRequests';

export type CreatePaymentRequest = import('./paymentRequests').CreatePaymentRequest;
export type PaymentRequest = import('./paymentRequests').PaymentRequest;
export type PayReqConversationParams = import('./paymentRequests').PayReqConversationParams;
export type CancelPaymentRequest = import('./paymentRequests').CancelPaymentRequest;
export type PaymentRequestsResponse = import('./paymentRequests').PaymentRequestsResponse;
export type SubmitIdealSource = import('./paymentRequests').SubmitIdealSource;
export type CheckIdealStatus = import('./paymentRequests').CheckIdealStatus;

const createOsiris = (fetchClient: FetchClient) => {
  const makeCall = createMakeCall(fetchClient);

  return {
    createPaymentRequest: createPaymentRequest(makeCall),
    createPaymentPlan: createPaymentPlan(makeCall),
    getPaymentRequests: getPaymentRequests(makeCall),
    getPaymentRequestByHandle: getPaymentRequestByHandle(makeCall),
    payPaymentRequestV2: payPaymentRequestV2(makeCall),
    payPaymentRequestV2Confirm: payPaymentRequestV2Confirm(makeCall),
    cancelPaymentRequest: cancelPaymentRequest(makeCall),
    submitIdealSource: submitIdealSource(makeCall),
    checkIdealStatus: checkIdealStatus(makeCall),
  };
};

export default createOsiris;
